 <template>
  <v-dialog v-model="isShow" persistent max-width="290" @modalClose="fechar()">
    <v-card>
      <v-card-title class="headline">
        Confirmação - {{title}}
      </v-card-title>
      <v-card-text>
        <p>{{body}}</p>
        <p>Essa operação não poderá ser desfeita. Tem certeza que deseja continuar?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        color="red darken-1" flat
        @click.native="cancelar">Cancelar</v-btn>
        <v-btn
        color="green darken-1" flat
        @click.native="confirmar">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'Confirmation',
  components: {
  },
  props: {
    isShow: false,
    title: '',
    body: ''
  },
  methods: {
    cancelar () {
      this.$emit('cancelar')
    },
    confirmar () {
      this.$emit('confirmar')
    },
    fechar () {
      this.$emit('fechar')
    }
  }
}
</script>

<style scoped>

.confirmationModal{
    z-index: 1060;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Calendario/confirmation.vue